/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Marker Management" |
*
* @param {Markers_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_form_label = /** @type {((inputs?: Markers_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestion des marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markerverwaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestione dei marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление маркерами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestión de marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记管理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカー管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर प्रबंधन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gestão de Marcadores")
	return /** @type {LocalizedString} */ ("Marker Management")
});